import { getAccessTokenRequest } from '../../../services/msal.services';
import {
  InteractionRequiredAuthError,
  InteractionStatus
} from '@azure/msal-browser';
import { useAccount, useMsal } from '@azure/msal-react';
import * as Sentry from '@sentry/react';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { checkSSO } from '../../../utils/msal';
import Spinner from '../Spinner';
import SideBar from "../../SideBar/SideBar";
import MainPage from './MainPage';

export const AuthTemplate = () => {
  const { instance, inProgress } = useMsal();
  const [isAuth, setIsAuth] = useState(false);

  const user = useAccount();

  useEffect(() => {
    if (!isAuth && inProgress === InteractionStatus.None) {
      checkSSO()
        .then(() => setIsAuth(true))
        .catch(e => {
          if (e instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(getAccessTokenRequest());
          }
        });
    }
  }, [inProgress, isAuth, instance]);

  useEffect(() => {
    if (user) {
      Sentry.setUser({
        email: user.username
      });
    }
  }, [inProgress, user]);

  return isAuth ? (
    <div className="flex h-screen w-screen bg-background">
      <SideBar />
      <MainPage>
        {inProgress !== InteractionStatus.None ? (
          <Spinner className="w-fit h-7" color="stroke-neutral" />
        ) : !isAuth ? (
          <div className="w-full h-full flex items-center justify-center flex-col gap-4">
            <h1 className="font-bold text-xl">Usuário deslogado, realize o login</h1>
            <button
              className="bg-blue-600 rounded px-5 py-2 text-white font-bold hover:bg-blue-500"
              onClick={() => {
                instance.loginRedirect();
              }}
            >
              Fazer login
            </button>
          </div>
        ) : (
              <Outlet />
        )}
      </MainPage>
    </div> 
  ) : (
    <Spinner className="flex h-screen w-screen justify-center items-center z-[999] w-50 h-50 bg-transparent" />
  );
};
